import * as React from 'react';
import { useParams,useNavigate } from 'react-router-dom';
//import firebase from 'firebase/compat';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import { styled } from '@mui/material/styles';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Grid from '@mui/material/Grid';
import { Paper } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Modal} from '@mui/material';
import {Box} from '@mui/material';
import {TextField} from '@mui/material';
import {FormControl} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { CircularProgress } from '@mui/material';
import { db } from '../../Environment/firebase';
import { IconButton } from '@mui/material';
import { Button } from '@mui/material';
import { NotFound } from '../../Pages/Error/NotFound';
import { getUserData,getUserDataFromAddress,UserDataType } from './getUserDataset';
import { doc,setDoc} from "firebase/firestore";

type UserManagementType = {
    userCategory:string
}



type TitleType = {
    children:string
  }
  
function Title(props:TitleType) {
    return (
    <Typography component="h2" variant="h6" color="success" gutterBottom>
        {props.children}
    </Typography>
    );
}

Title.propTypes = {
    children: PropTypes.node,
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 24,
    },
}));

const Modalstyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 500,
    minWidth:300,
    display:'grid',
    alignContents: 'center',
    justifyItems:"center",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

export default function UserManagement(props:UserManagementType): JSX.Element {

    const userCategory = props.userCategory;
    const [userDataRows,setUserDataRows] = React.useState<UserDataType[]>([]);
    const [searchAddress,setSearchAddress] = React.useState<string>("");
    const [searchAddressData,setSearchAddressData] = React.useState<UserDataType[]>([]);
    const [diplayResult,setDisplayResult]= React.useState<boolean>(false);
    const [open,setOpen] = React.useState<boolean>(false);
    const [deleteModalOpen,setDeleteModalOpen] = React.useState<boolean>(false);
    const [addingProcess,setAddingProcess] = React.useState<boolean>(false);
    const [page, setPage] = React.useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [update,setUpdate]= React.useState<boolean>(false);


  
  const [offline,setOffline]= React.useState(false);
  

    const handleChangePage = (event: unknown, newPage:number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event:React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    };

    async function upload(id:string,userStatus:string){
        const result = await setDoc(doc(db, "users", id), {userStatus:userStatus,uid:id},{ merge: true });
        return result
    }

    async function normalize(id:string){
        const result = await setDoc(doc(db, "users", id), {userStatus:'normal',uid:id},{ merge: true });
        return result
    }

    const getQuery = () =>{
        getUserDataFromAddress(searchAddress)
        .then(result => {
            setSearchAddressData(result)
            setDisplayResult(true)
        })
    }

    const addAuth = (id:string,userStatus:string) => {
        setAddingProcess(true);
        upload(id,userStatus).then(result=>{
            getUserData(userCategory)
            .then(userDatas => {
                setUserDataRows(userDatas);
                setOpen(false);
                setDisplayResult(false);
                setAddingProcess(false);
                setUpdate(!update)
                })        
        })
    }

    const delAuth = (id:string) => {
        setDeleteModalOpen(true);
        normalize(id).then(result=>{
            getUserData(userCategory)
            .then(userDatas => {
                setUserDataRows(userDatas);
                setDeleteModalOpen(false);
                setDisplayResult(false);
                setUpdate(!update);
            })
        })
    }
  
  React.useEffect(()=>{   
    getUserData(userCategory)
    .then(userDatas => setUserDataRows(userDatas))
    .catch((err)=>{
        if(String(err).includes('client is offline')){
          setOffline(true)
        }
      })
    },[]);
  
  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, []) 
   
  return (
    <React.Fragment>
            <Grid item display={'flex'} gap={3} m={2}>
                <Title>{userCategory}</Title>
                <Button variant="contained" onClick={()=>setOpen(true)}>追加</Button>
            </Grid>            
            <Grid display={{md:'flex',sm:'grid'}} gap={2}>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                >
                <Box sx={Modalstyle}>
                    <FormControl fullWidth sx={{ mt: 0.5 }}>  
                        <TextField id="standard-basic" label="メールアドレス" variant="standard" 
                        value={searchAddress}
                        onChange={(event) => {
                            setSearchAddress(event.target.value);
                        }}/>
                    </FormControl>
                    <div>
                        {diplayResult?
                            <div>
                                {searchAddressData.length > 0 ?
                                <Grid>
                                    <Typography variant="h5" gutterBottom>
                                        "{searchAddressData[0].displayName}" に "{userCategory}" を付与しますか？
                                    </Typography>
                                    <Grid sx={{display:'flex',gap:3,mt:2}}>
                                        <Button variant="text" onClick={()=>{setOpen(false)
                                                                            setDisplayResult(false)}}>キャンセル</Button>
                                        <Button variant="contained" onClick={()=>addAuth(searchAddressData[0].uid,userCategory)}>追加</Button>
                                    </Grid>
                                    
                                </Grid>:
                                <Grid>
                                    <Typography variant="h5" gutterBottom>
                                    該当データがありません。
                                    </Typography>
                                    <Button variant="text" onClick={()=>{setOpen(false)
                                                                        setDisplayResult(false)}}>閉じる</Button>
                                </Grid>
                                }
                            </div> : <div>{addingProcess?
                                <Grid>
                                    <CircularProgress></CircularProgress>
                                    <Typography variant="h5" gutterBottom>
                                        権限を追加中です。
                                    </Typography>                                    
                                </Grid> :
                                <Grid sx={{display:'flex',gap:3,mt:2}}>
                                    <Button variant="text" onClick={()=>setOpen(false)}>キャンセル</Button>
                                    <Button variant="contained" onClick={getQuery}>検索</Button>
                                </Grid>}
                            </div>                       
                        }
                    </div>                                                 
                </Box>
            </Modal>
            <Modal
                open={deleteModalOpen}
                onClose={() => setDeleteModalOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                >
                <Box sx={Modalstyle}>                   
                    <Grid>
                        <CircularProgress></CircularProgress>
                        <Typography variant="h5" gutterBottom>
                            権限を削除中です。
                        </Typography>                                    
                    </Grid>                                             
                </Box>
            </Modal>
            </Grid>
            <Paper sx={{ width: '100%', mb: 2 }}>
                <TableContainer>
                    <Table
                    sx={{ minWidth: 740 }}
                    aria-labelledby="tableTitle"
                    size={ 'small' }
                    >
                        <TableHead>
                            <TableRow>                        
                                <StyledTableCell align="center">e-mail</StyledTableCell>
                                <StyledTableCell align='center'>名前</StyledTableCell>
                                <StyledTableCell align="center">ログイン日</StyledTableCell>
                                <StyledTableCell align="center">権限</StyledTableCell>
                                <StyledTableCell align="center">権限を削除</StyledTableCell>
                            </TableRow>
                        </TableHead>                   
                        {userDataRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row,index) => {
                        return(
                        <TableBody>
                            <TableRow key={row.uid} >                    
                                <TableCell align='center'>{row.email}</TableCell>
                                <TableCell align='center'>{row.displayName}</TableCell>                    
                                <TableCell align='center'>{row.loginDates}</TableCell>
                                <TableCell align='center'>{row.userStatus}</TableCell>
                                <TableCell align='center' >
                                <IconButton aria-haspopup="true" onClick={()=>delAuth(row.uid)}>
                                <DeleteIcon color='success'/>
                                </IconButton>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                        )})}                        
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={userDataRows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </React.Fragment>
  );
}